import { render, staticRenderFns } from "./car-ownership-cost.vue?vue&type=template&id=3bc36710&"
import script from "./car-ownership-cost.vue?vue&type=script&lang=js&"
export * from "./car-ownership-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default})
